// types
import { IUser } from 'types/graphql'
// utils
import get from 'lodash/get'
import map from 'lodash/fp/map'
import pipe from 'lodash/fp/pipe'
import { safeGetOr } from './fp'

export const generateUserName = (user: IUser) => {
  return `${get(user, 'firstName', '')} ${get(user, 'lastName', '')}`.trim()
}

export const isCurrentUser = (id, user) => {
  const myPositionIds = pipe<any, any, any>(
    safeGetOr([], 'positions'),
    map('id')
  )(user)

  return id === user.id || myPositionIds.some(positionId => positionId === id)
}
